<template>
  <div v-for="notification in notifications">
    <div v-if="!notification.read" class="promo-message-animation">
      <transition name="slide">
        <div class="w-home-flexible-promo" v-show="!hidden">
          <div class="w-home-flexible-promo-row">
            <div class="w-home-flexible-promo-wrapper">
              <div class="promo-message-pig promo-message-pig-common">
                <a href="javascript:void(0)" class="close-sdn-notification-link" @click="closeBanner(notification)">
                  <i class="fa-solid fa-close"></i>
                </a>
                <h4>Hi, {{sdnData.userName}}.</h4>
                <div class="promo-message-mascot">
                  <div class="notification-message" v-html="notification.message.html_msg"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import { mapGetters } from 'vuex'
  import { addAlertViewEvent } from 'application/ga_alert_view_event'
  import { setNotificationRead } from '../api/api'

  export default {
    props: {
      sdnData: {
        type: Object
      }
    },
    data() {
      return {
        hidden: false
      }
    },
    computed: {
      ...mapGetters(['notifications']),
    },
    watch: {
      notifications: {
        immediate: true,
        handler(newNotifications) {
          if (newNotifications && newNotifications.length > 0) {
            this.notificationAlertViewEvents(newNotifications[0])
            this.addClickListenerToLink(newNotifications[0])
          }
        },
      },
    },
    methods: {
      closeBanner(notification) {
        // GA event
        SOPHIA.clickToggleForGA({
          el: $('.close-sdn-notification-link'),
          eventAction: 'close',
          moduleName: 'sdn notification banner',
          clickText: 'close banner',
          fieldType: 'switch'
        })

        // snowplow
        snowplow('trackStructEvent', {
          category: 'sdn_notification_banner',
          action: 'dismiss',
          label: notification.message.sdn_msg_type
        });

        this.hidden = true
        setNotificationRead(notification.id)
      },
      addClickListenerToLink(notification) {
        this.$nextTick(() => {
          // GA event
          SOPHIA.clickLinkForGA($('.notification-message'), { moduleName: 'sdn notification banner' })

          $('.notification-message a').off('click.notification').on('click.notification', () => {
            // snowplow
            snowplow('trackStructEvent', {
              category: 'sdn_notification_banner',
              action: 'click',
              label: notification.message.sdn_msg_type
            });
          });
        });
      },
      notificationAlertViewEvents(notification) {
        if (!notification.read) { // only if there is unread message
          // GA event
          const ga_alert_view_data = {
            alert_name: notification.message.sdn_msg_type,
            alert_id: '',
            event_detail: 'sdn notification banner'
          }
          addAlertViewEvent(ga_alert_view_data)

          // snowplow
          snowplow('trackStructEvent', {
            category: 'sdn_notification_banner',
            action: 'impression',
            label: notification.message.sdn_msg_type
          });
        }
      },
      ABTestingBannerWidth() {

      }
    }
  }
</script>
